export default {
  name: "ConfirmationModal",
  props: {},
  data() {
    return {};
  },
  methods: {
    allow() {
      this.onClose(true);
    },
    deny() {
      this.onClose(false);
    },
    onClose(param) {
      this.$emit("onClose", param);
    }
  }
};
